// extracted by mini-css-extract-plugin
export default {"socialButtonsWrapper":"SocialButtons_socialButtonsWrapper__dpWUS","socialButton":"SocialButtons_socialButton__rKe2k","shortView":"SocialButtons_shortView__nw7HD"};